module.exports = __webpack_public_path__ + "static/media/nlp-medical.c151ef53.gif";